var exports = {
  "AS": "xa15a2ab7--020ab8--item",
  "Sl": "xa15a2ab7--020ab8--image",
  "Qs": "xa15a2ab7--020ab8--content",
};

module.exports = exports;
